import { useCallback, useState } from 'react'

export const useForceRerender = (): (() => void) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_update, setUpdate] = useState(false)
  return useCallback(() => setUpdate(value => !value), [])
}
